<template>
  <ChipTagV2 class="chip-class">
    Soon
    <Tooltip 
      text="The list will be available once the scheduler opens"
      location="bottom"
    />
  </ChipTagV2>
</template>
<script setup>
import ChipTagV2 from '@design_system_v3/components/atoms/ChipTagV2.vue';
import Tooltip from '@design_system_v3/components/atoms/Tooltip.vue';
</script>
<style scoped lang="scss">
.chip-class {
  display: inline;
}
</style>